// extracted by mini-css-extract-plugin
module.exports = {"analytics-panels":"styles-module__analytics-panels___OWFcb"};